@if (isAuthoring) {
  <p>
    <em>AUTHORING : County specific queries will not load reliably due to no county selected! Test in Publish!</em>
  </p>
}

@if (!filesByCounty) {
  <p>
    Finding plans for your county...
    <mat-spinner></mat-spinner>
  </p>
}

@if (noDocumentsFound) {
  <p>
    <strong>No Plan Documents were found.</strong>
  </p>
}

@if (componentError) {
  <p>
    The documentation requested was not reachable. Please try again later.
  </p>
}

<section [ngClass]="{'hide': noDocumentsFound || !filesByCounty || filesByCounty?.productDocuments.length === 0}">
  <h2>{{ productHeadingDesc }}</h2>
  @for (file of filesByCounty?.productDocuments; track file; let i = $index) {
    <div class="cell"
      [ngClass]="{'top-cell' : i === 0 }">
      <a href="{{file.filePath}}" class="link" target="_blank">
        <span class="material-symbols-outlined"> picture_as_pdf </span>
        {{file.title}}
      </a>
    </div>
  }
</section>
<section [ngClass]="{'hide': noDocumentsFound || planList.length === 0}">
  <h2>{{ planHeadingDesc }}</h2>
  <div class="special-plan-section">
    @for (plan of planList; track plan; let i = $index) {
      <div class="outer-div"
        [ngClass]="{'hide': !filesByCounty?.planDocuments[plan] || filesByCounty?.planDocuments[plan].length === 0}">
        <div class="cell-plan">
          <div class="margin-div">
            <span class="header">{{plan}}</span>
          </div>
        </div>
        @for (file of filesByCounty?.planDocuments[plan]; track file; let i = $index) {
          <div class="cell">
            <a href="{{file.filePath}}" class="link" target="_blank">
              <span class="material-symbols-outlined"> picture_as_pdf </span>
              {{file.title}}
            </a>
          </div>
        }
      </div>
    }
  </div>
</section>